import * as glMatrix from 'gl-matrix';
import { Vec2Input } from '../types/gl';

export const createGpuBufferFromMat4 = (
  device: GPUDevice,
  mat4: glMatrix.mat4,
  usage: GPUBufferUsageFlags
) => {
  mat4 = new Float32Array(mat4);
  const gpuBuffer = device.createBuffer({
    size: mat4.byteLength,
    usage,
    mappedAtCreation: true,
  });
  const writeArray = new Float32Array(gpuBuffer.getMappedRange());
  writeArray.set(mat4);
  gpuBuffer.unmap();
  return gpuBuffer;
};

export const createGpuBufferFromFloat = (
  device: GPUDevice,
  float: number,
  usage: GPUBufferUsageFlags
) => {
  const gpuBuffer = device.createBuffer({
    size: 4,
    usage,
    mappedAtCreation: true,
  });
  const writeArray = new Float32Array(gpuBuffer.getMappedRange());
  writeArray[0] = float;
  gpuBuffer.unmap();
  return gpuBuffer;
};

export const createGpuBufferFromVec2 = (
  device: GPUDevice,
  vec2: Vec2Input,
  usage: GPUBufferUsageFlags
) => {
  const gpuBuffer = device.createBuffer({
    size: 8,
    usage,
    mappedAtCreation: true,
  });
  const writeArray = new Float32Array(gpuBuffer.getMappedRange());
  writeArray.set(vec2);
  gpuBuffer.unmap();
  return gpuBuffer;
};

// Note: We disallow negative values as this is used for timestamp queries
// where it's possible for a query to return a beginning time greater than the
// end time. See: https://gpuweb.github.io/gpuweb/#timestamp
export class NonNegativeRollingAverage {
  #total = 0;
  #samples: number[] = [];
  #cursor = 0;
  #numSamples;
  constructor(numSamples = 30) {
    this.#numSamples = numSamples;
  }
  addSample(v: number) {
    if (!Number.isNaN(v) && Number.isFinite(v) && v >= 0) {
      this.#total += v - (this.#samples[this.#cursor] || 0);
      this.#samples[this.#cursor] = v;
      this.#cursor = (this.#cursor + 1) % this.#numSamples;
    }
  }
  get() {
    return this.#total / this.#samples.length;
  }
}
